/** Página do simulador (MV2-2006). Fica fora do formulário para ter a rolagem da página. */
export const SIMULATOR_PATH = '/virtual-groups/smart-charging/simulator';

type SimulatorUrlParams = {
  smartChargingId?: string | null;
  chargeBoxIds?: string[];
  currentNominalA?: number | null;
};

/** O cenário vai pela URL: a página pode ser recarregada ou compartilhada sem perder o grupo. */
export const simulatorUrl = ({ smartChargingId, chargeBoxIds, currentNominalA }: SimulatorUrlParams) => {
  const params = new URLSearchParams();

  if (smartChargingId) {
    params.set('smart_charging_id', smartChargingId);
  } else if (chargeBoxIds?.length) {
    params.set('charge_box_ids', chargeBoxIds.filter(Boolean).join(','));
  }

  if (currentNominalA && currentNominalA > 0) {
    params.set('current_nominal_a', String(currentNominalA));
  }

  const query = params.toString();
  return query ? `${SIMULATOR_PATH}?${query}` : SIMULATOR_PATH;
};

export const readSimulatorUrl = (search: string) => {
  const params = new URLSearchParams(search);
  const limit = Number(params.get('current_nominal_a'));

  return {
    smartChargingId: params.get('smart_charging_id'),
    chargeBoxIds: (params.get('charge_box_ids') || '').split(',').filter(Boolean),
    currentNominalA: limit > 0 ? limit : null,
  };
};
